import { createHeaders } from '@wix/headers';
import { extractHost, isAbsoluteUrl } from './utils';
import whitelistedHosts from './whitelist.json';
export function requestIdOrEmptyString(response) {
    var _a;
    return ((_a = response === null || response === void 0 ? void 0 : response.headers) === null || _a === void 0 ? void 0 : _a['x-wix-request-id']) || '';
}
export const composeHeaders = ({ url, disableWixHeaders, wixHeadersOpts, }) => {
    const shouldAssignWixHeaders = !disableWixHeaders && isWixDomain(url);
    return shouldAssignWixHeaders ? createHeaders(wixHeadersOpts) : {};
};
export function isWixDomain(url) {
    const isRelative = !isAbsoluteUrl(url);
    if (isRelative) {
        return true;
    }
    const host = `.${extractHost(url)}`;
    const isWhitelisted = whitelistedHosts.find((wixHost) => host.endsWith(`.${wixHost}`));
    return !!isWhitelisted;
}
//# sourceMappingURL=headers.js.map